"use client";

import type { ComponentType, ReactNode } from "react";
import { Loader2, type LucideProps } from "lucide-react";
import { StudioButton } from "../StudioButton";
import { StudioDialog } from "./StudioDialog";

/** Yes/no confirm. Replaces one-off confirm overlays as they migrate. */
export function StudioConfirm({
  open,
  title,
  body,
  icon: Icon,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  busy = false,
  onConfirm,
  onClose,
  children,
}: {
  open: boolean;
  title: string;
  body?: string;
  icon?: ComponentType<LucideProps>;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
}) {
  return (
    <StudioDialog
      open={open}
      showClose={false}
      onClose={() => {
        if (!busy) onClose();
      }}
      title={title}
    >
      <div className="studio-overlay-confirm">
        {Icon && !busy ? (
          <div className={`studio-overlay-confirm-icon${danger ? " is-danger" : ""}`} aria-hidden="true">
            <Icon strokeWidth={1.75} />
          </div>
        ) : null}
        {body ? <p className="studio-overlay-confirm-body">{body}</p> : null}
        {children}
        <div className="studio-overlay-confirm-actions">
          <StudioButton variant="secondary" disabled={busy} onClick={onClose}>
            {cancelLabel}
          </StudioButton>
          <StudioButton
            variant={danger ? "danger" : "primary"}
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? <Loader2 className="studio-overlay-confirm-btn-spin" aria-hidden="true" /> : null}
            {confirmLabel}
          </StudioButton>
        </div>
      </div>
    </StudioDialog>
  );
}
